module.exports = `${require.publicPath}icon11.965395f0.png`;